/* eslint-disable react-refresh/only-export-components -- bootstrap entry */
import "core-js/proposals/string-replace-all";
import React from "react";
import { initializeMuiLicense } from "./config/muiLicense";

if (typeof initializeMuiLicense === 'function') {
  initializeMuiLicense();
}

import App from "./components/App";
import { Provider } from "react-redux";
import rootSaga from "./store/sagas";
import createSagaMiddleware from "redux-saga";
import "./i18n";
import "./yupLocalization";
import configureStore from "./store/configureStore";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/queryClient";
import { EventLogProvider } from "./hooks/useEventLog";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore(sagaMiddleware);
sagaMiddleware.run(rootSaga);

const container = document.querySelector("#root");
const root = createRoot(container);

const Devtools = import.meta.env.DEV
  ? React.lazy(() =>
      import('@tanstack/react-query-devtools').then(m => ({ default: m.ReactQueryDevtools }))
    )
  : () => null;

root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <EventLogProvider>
                    <App />
                </EventLogProvider>
            </BrowserRouter>
            {import.meta.env.DEV && (
              <React.Suspense fallback={null}>
                <Devtools initialIsOpen={false} buttonPosition="bottom-left" />
              </React.Suspense>
            )}
        </QueryClientProvider>
    </Provider>
);
